// Mock data for The WHY ME Foundation website

export const stats = [
  { number: '500+', label: 'Youth Served' },
  { number: '3', label: 'Core Programs' },
  { number: '75%', label: 'At-Risk Youth Supported' },
  { number: '100+', label: 'Volunteer Hours' }
];

export const programs = [
  {
    id: 'prepare',
    title: 'Prepare ME',
    subtitle: 'Life Skills Development',
    description: 'Strengthening foundational cognitive, social, and practical skills through experiential learning and real-world applications.',
    icon: 'Target',
    features: [
      'Age-appropriate cognitive development activities',
      'Hands-on experiential learning',
      'Open-source educational tools',
      'Independence and decision-making skills'
    ]
  },
  {
    id: 'guide',
    title: 'Guide ME',
    subtitle: 'Academic & Entrepreneurial Guidance',
    description: 'Connecting students with professionals, academic advisors, and industry experts for mentorship and career exploration.',
    icon: 'Compass',
    features: [
      'STEM exposure and career pathways',
      'Financial literacy education',
      'Mentorship from industry professionals',
      'College and career readiness support'
    ]
  },
  {
    id: 'recruit',
    title: 'Recruit ME',
    subtitle: 'Extracurricular & NIL Development',
    description: 'Structured exposure through clubs, community service, and NIL education for student-athletes.',
    icon: 'Users',
    features: [
      'Extracurricular clubs and activities',
      'Community service opportunities',
      'NIL workshops for student-athletes',
      'Personal branding and communication skills'
    ]
  }
];

export const clubs = [
  {
    name: 'Youth Sports',
    description: 'Basketball, track, and football programs focused on athletic and personal growth.',
    image: 'https://customer-assets.emergentagent.com/job_why-me-org/artifacts/sysufm8j_ME%2012u.png',
    link: '/youth-sports'
  },
  {
    name: 'Running Club',
    description: 'Building endurance, discipline, and teamwork through structured running programs.',
    image: 'https://customer-assets.emergentagent.com/job_why-me-org/artifacts/mdkmyo0b_RUNWME.jpg'
  },
  {
    name: 'Community Service',
    description: 'Feed The Youth and other community-driven initiatives teaching leadership and service.',
    image: 'https://customer-assets.emergentagent.com/job_why-me-org/artifacts/8z4wu2lr_WHYME%20BKFST.jpg',
    link: '/community-service'
  }
];

export const heroImage = 'https://customer-assets.emergentagent.com/job_why-me-org/artifacts/bovmn8mg_IMG_0088.jpg';

export const sponsorshipTiers = [
  {
    tier: 'Platinum',
    amount: '$10,000+',
    benefits: [
      'Naming rights for major events',
      'Logo placement on all materials',
      'Featured in media campaigns',
      'Exclusive recognition at gala',
      'Quarterly impact reports'
    ]
  },
  {
    tier: 'Gold',
    amount: '$5,000 - $9,999',
    benefits: [
      'Event sponsorship opportunities',
      'Logo on promotional materials',
      'Social media highlights',
      'Recognition at events',
      'Annual impact report'
    ]
  },
  {
    tier: 'Silver',
    amount: '$2,500 - $4,999',
    benefits: [
      'Program sponsor recognition',
      'Logo on website',
      'Digital mentions',
      'Event invitations',
      'Tax-deductible receipt'
    ]
  },
  {
    tier: 'Bronze',
    amount: '$1,000 - $2,499',
    benefits: [
      'Community supporter listing',
      'Website recognition',
      'Newsletter features',
      'Event access',
      'Tax-deductible receipt'
    ]
  }
];

export const impactAreas = [
  {
    title: 'Life Skills Development',
    description: 'Early cognitive and practical skill building',
    icon: 'Brain'
  },
  {
    title: 'Academic Excellence',
    description: 'College and career readiness support',
    icon: 'GraduationCap'
  },
  {
    title: 'Financial Literacy',
    description: 'Wealth-building and entrepreneurship education',
    icon: 'DollarSign'
  },
  {
    title: 'Community Service',
    description: 'Leadership through civic engagement',
    icon: 'Heart'
  },
  {
    title: 'Athletic Development',
    description: 'Sports programs and NIL education',
    icon: 'Trophy'
  },
  {
    title: 'Mentorship',
    description: 'Connections with industry professionals',
    icon: 'Handshake'
  }
];

export const testimonials = [
  {
    quote: 'The WHY ME Foundation has given my son opportunities I never thought possible. The mentorship and guidance have been life-changing.',
    author: 'Parent, Aldine ISD',
    role: 'Parent'
  },
  {
    quote: 'Through the Guide ME program, I discovered my passion for engineering and got connected with professionals who are helping me plan my future.',
    author: 'Student Participant',
    role: 'Program Participant'
  },
  {
    quote: 'Volunteering with WHY ME has been incredibly rewarding. Seeing these kids grow and thrive is what community is all about.',
    author: 'Community Volunteer',
    role: 'Volunteer'
  }
];
